// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/contractor_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContractorListItem } from "./customer_model_pb";
import { file_bffuser_v1_customer_model } from "./customer_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/contractor_service.proto.
 */
export const file_bffuser_v1_contractor_service: GenFile = /*@__PURE__*/
  fileDesc("CiNiZmZ1c2VyL3YxL2NvbnRyYWN0b3Jfc2VydmljZS5wcm90bxIKYmZmdXNlci52MSIYChZMaXN0Q29udHJhY3RvcnNSZXF1ZXN0Ik4KF0xpc3RDb250cmFjdG9yc1Jlc3BvbnNlEjMKC2NvbnRyYWN0b3JzGAEgAygLMh4uYmZmdXNlci52MS5Db250cmFjdG9yTGlzdEl0ZW0iuAEKF0NyZWF0ZUNvbnRyYWN0b3JSZXF1ZXN0EhYKBG5hbWUYASABKAlCCLpIBXIDGOgHEiUKE2JpbGxpbmdfcG9zdGFsX2NvZGUYAiABKAlCCLpIBXIDGOgHEiEKD2JpbGxpbmdfYWRkcmVzcxgDIAEoCUIIukgFcgMYiCcSIwoRYmlsbGluZ19hdHRlbnRpb24YBCABKAlCCLpIBXIDGOgHEhYKBG5vdGUYBSABKAlCCLpIBXIDGIgnImEKGENyZWF0ZUNvbnRyYWN0b3JSZXNwb25zZRIVCg1jb250cmFjdG9yX2lkGAEgASgJEi4KCnVwZGF0ZWRfYXQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIpoCChdVcGRhdGVDb250cmFjdG9yUmVxdWVzdBIfCg1jb250cmFjdG9yX2lkGAEgASgJQgi6SAVyA7ABARIWCgRuYW1lGAIgASgJQgi6SAVyAxjoBxIlChNiaWxsaW5nX3Bvc3RhbF9jb2RlGAMgASgJQgi6SAVyAxjoBxIhCg9iaWxsaW5nX2FkZHJlc3MYBCABKAlCCLpIBXIDGIgnEiMKEWJpbGxpbmdfYXR0ZW50aW9uGAUgASgJQgi6SAVyAxjoBxIWCgRub3RlGAYgASgJQgi6SAVyAxiIJxI/ChNleHBlY3RlZF91cGRhdGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIGukgDyAEBIkoKGFVwZGF0ZUNvbnRyYWN0b3JSZXNwb25zZRIuCgp1cGRhdGVkX2F0GAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCI6ChdEZWxldGVDb250cmFjdG9yUmVxdWVzdBIfCg1jb250cmFjdG9yX2lkGAEgASgJQgi6SAVyA7ABASIaChhEZWxldGVDb250cmFjdG9yUmVzcG9uc2UyjAMKEUNvbnRyYWN0b3JTZXJ2aWNlEloKD0xpc3RDb250cmFjdG9ycxIiLmJmZnVzZXIudjEuTGlzdENvbnRyYWN0b3JzUmVxdWVzdBojLmJmZnVzZXIudjEuTGlzdENvbnRyYWN0b3JzUmVzcG9uc2USXQoQQ3JlYXRlQ29udHJhY3RvchIjLmJmZnVzZXIudjEuQ3JlYXRlQ29udHJhY3RvclJlcXVlc3QaJC5iZmZ1c2VyLnYxLkNyZWF0ZUNvbnRyYWN0b3JSZXNwb25zZRJdChBVcGRhdGVDb250cmFjdG9yEiMuYmZmdXNlci52MS5VcGRhdGVDb250cmFjdG9yUmVxdWVzdBokLmJmZnVzZXIudjEuVXBkYXRlQ29udHJhY3RvclJlc3BvbnNlEl0KEERlbGV0ZUNvbnRyYWN0b3ISIy5iZmZ1c2VyLnYxLkRlbGV0ZUNvbnRyYWN0b3JSZXF1ZXN0GiQuYmZmdXNlci52MS5EZWxldGVDb250cmFjdG9yUmVzcG9uc2VCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bffuser_v1_customer_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * @generated from message bffuser.v1.ListContractorsRequest
 */
export type ListContractorsRequest = Message<"bffuser.v1.ListContractorsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListContractorsRequest.
 * Use `create(ListContractorsRequestSchema)` to create a new message.
 */
export const ListContractorsRequestSchema: GenMessage<ListContractorsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_contractor_service, 0);

/**
 * @generated from message bffuser.v1.ListContractorsResponse
 */
export type ListContractorsResponse = Message<"bffuser.v1.ListContractorsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.ContractorListItem contractors = 1;
   */
  contractors: ContractorListItem[];
};

/**
 * Describes the message bffuser.v1.ListContractorsResponse.
 * Use `create(ListContractorsResponseSchema)` to create a new message.
 */
export const ListContractorsResponseSchema: GenMessage<ListContractorsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_contractor_service, 1);

/**
 * @generated from message bffuser.v1.CreateContractorRequest
 */
export type CreateContractorRequest = Message<"bffuser.v1.CreateContractorRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string billing_postal_code = 2;
   */
  billingPostalCode: string;

  /**
   * @generated from field: string billing_address = 3;
   */
  billingAddress: string;

  /**
   * @generated from field: string billing_attention = 4;
   */
  billingAttention: string;

  /**
   * @generated from field: string note = 5;
   */
  note: string;
};

/**
 * Describes the message bffuser.v1.CreateContractorRequest.
 * Use `create(CreateContractorRequestSchema)` to create a new message.
 */
export const CreateContractorRequestSchema: GenMessage<CreateContractorRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_contractor_service, 2);

/**
 * @generated from message bffuser.v1.CreateContractorResponse
 */
export type CreateContractorResponse = Message<"bffuser.v1.CreateContractorResponse"> & {
  /**
   * @generated from field: string contractor_id = 1;
   */
  contractorId: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.CreateContractorResponse.
 * Use `create(CreateContractorResponseSchema)` to create a new message.
 */
export const CreateContractorResponseSchema: GenMessage<CreateContractorResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_contractor_service, 3);

/**
 * @generated from message bffuser.v1.UpdateContractorRequest
 */
export type UpdateContractorRequest = Message<"bffuser.v1.UpdateContractorRequest"> & {
  /**
   * @generated from field: string contractor_id = 1;
   */
  contractorId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string billing_postal_code = 3;
   */
  billingPostalCode: string;

  /**
   * @generated from field: string billing_address = 4;
   */
  billingAddress: string;

  /**
   * @generated from field: string billing_attention = 5;
   */
  billingAttention: string;

  /**
   * @generated from field: string note = 6;
   */
  note: string;

  /**
   * 画面が取得した契約者の updated_at。他の人が先に保存していたら CONFLICT で拒否する (楽観ロック)。
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 7;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateContractorRequest.
 * Use `create(UpdateContractorRequestSchema)` to create a new message.
 */
export const UpdateContractorRequestSchema: GenMessage<UpdateContractorRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_contractor_service, 4);

/**
 * @generated from message bffuser.v1.UpdateContractorResponse
 */
export type UpdateContractorResponse = Message<"bffuser.v1.UpdateContractorResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateContractorResponse.
 * Use `create(UpdateContractorResponseSchema)` to create a new message.
 */
export const UpdateContractorResponseSchema: GenMessage<UpdateContractorResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_contractor_service, 5);

/**
 * @generated from message bffuser.v1.DeleteContractorRequest
 */
export type DeleteContractorRequest = Message<"bffuser.v1.DeleteContractorRequest"> & {
  /**
   * @generated from field: string contractor_id = 1;
   */
  contractorId: string;
};

/**
 * Describes the message bffuser.v1.DeleteContractorRequest.
 * Use `create(DeleteContractorRequestSchema)` to create a new message.
 */
export const DeleteContractorRequestSchema: GenMessage<DeleteContractorRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_contractor_service, 6);

/**
 * @generated from message bffuser.v1.DeleteContractorResponse
 */
export type DeleteContractorResponse = Message<"bffuser.v1.DeleteContractorResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteContractorResponse.
 * Use `create(DeleteContractorResponseSchema)` to create a new message.
 */
export const DeleteContractorResponseSchema: GenMessage<DeleteContractorResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_contractor_service, 7);

/**
 * ContractorService は契約者の一覧・追加・編集・削除を扱う。organization_id と
 * acting_member_id は露出させず BFF が eauth セッションから補完する (multitenant.md)。
 * internalapi.v1.ContractorService の薄い pass-through。
 *
 * @generated from service bffuser.v1.ContractorService
 */
export const ContractorService: GenService<{
  /**
   * @generated from rpc bffuser.v1.ContractorService.ListContractors
   */
  listContractors: {
    methodKind: "unary";
    input: typeof ListContractorsRequestSchema;
    output: typeof ListContractorsResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.ContractorService.CreateContractor
   */
  createContractor: {
    methodKind: "unary";
    input: typeof CreateContractorRequestSchema;
    output: typeof CreateContractorResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.ContractorService.UpdateContractor
   */
  updateContractor: {
    methodKind: "unary";
    input: typeof UpdateContractorRequestSchema;
    output: typeof UpdateContractorResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.ContractorService.DeleteContractor
   */
  deleteContractor: {
    methodKind: "unary";
    input: typeof DeleteContractorRequestSchema;
    output: typeof DeleteContractorResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_contractor_service, 0);

